import m from "../../../../geodata/es2015/region/usa/kyHigh";
window.am4geodata_region_usa_kyHigh = m;


//////////////////
// WEBPACK FOOTER
// ./geodata/region/usa/kyHigh.js
// module id = null
// module chunks = 